/*
 * The welcome cards' spend-coverage notice: which delivering platforms have no
 * client-billed spend figure, and so are not in the card's total.
 *
 * Missing is never zero. A platform can deliver in a window without a
 * client-billed spend figure (Amazon Ads with no campaign terms reads
 * `basis_unavailable`): its impressions and clicks are real, but it has no
 * dollars to add. Leaving it out of "$X across N platforms" without saying so
 * presents a partial total as the whole.
 *
 * Both welcome cards (Quantum's CrossPlatformPerformancePreview and Cortex's
 * ClientPerformancePreview) state this sentence from here. Byte-pinned across
 * the two repositories, so the wording cannot drift between portals.
 */
export function describeSpendUnavailable(labels = []) {
  const names = [
    ...new Set(
      (Array.isArray(labels) ? labels : [])
        .map((label) => String(label ?? "").trim())
        .filter(Boolean)
    ),
  ];
  if (!names.length) return "";
  const list =
    names.length === 1
      ? names[0]
      : `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;
  return `${list} spend is unavailable for this window and is not in the total.`;
}
